import { createAsyncThunk } from "@reduxjs/toolkit";
import 'react-toastify/dist/ReactToastify.css';

import {
    getCityByStateId,
  getState as getStatesApi,
  getZonesByCityId,
  getZonesByNighborhoodId,
  
} from "../../helpers/backend_helper";

export const getStates = createAsyncThunk(
    "state/get",
    async () => {
      try {
        const response = await getStatesApi();
        return response.data; 
      } catch (error) {
        throw error;
      }
    }
);


export const getCities = createAsyncThunk(
    'cities/get',
    async (stateId: string | number, { rejectWithValue }) => {
      try {
        const response = await getCityByStateId(stateId);
        return response.data; 
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Something went wrong');
      }
    }
  );
  
  export const getZones = createAsyncThunk(
    'zones/get',
    async (cityId: string | number, { rejectWithValue }) => {
      try {
        const response = await getZonesByCityId(cityId);
        return response.data; 
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Something went wrong');
      }
    }
  );

  export const getNeighborhood = createAsyncThunk(
    'neighborhood/get',
    async (zoneid: string | number, { rejectWithValue }) => {
      try {
        const response = await getZonesByNighborhoodId(zoneid);
        return response.data; 
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Something went wrong');
      }
    }
  );